const Modal = ({
  theme = 'light', children, className, ...property
}) => (
  <div className={`fixed backdrop-filter overflow-y-auto inset-0 z-50 ${theme === 'light' ? 'bg-modalBg backdrop-blur-30' : 'bg-black bg-opacity-50'} [&>div]:animate-slideUp top-0 bottom-0 right-0 left-0 ${className}`} {...property}>
    {children}
  </div>
);

export default Modal;
